module.exports = __webpack_public_path__ + "img/solution-vil-system-pic-1.717ea24a.jpeg";